import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  onClick,
  hoverEffect = false
}: CardProps) {
  return <motion.div className={`bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden ${className}`} onClick={onClick} whileHover={hoverEffect && onClick ? {
    y: -4,
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
  } : {}} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 20
  }} data-id="element-1027">
      {children}
    </motion.div>;
}